import { React, useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box, Radio, RadioGroup, FormControlLabel, FormLabel, Button } from "@material-ui/core";
import TextField from '@material-ui/core/TextField';
import { useLocation, useHistory } from 'react-router-dom'
import CropFreeIcon from '@material-ui/icons/CropFree';
import QrReader from 'react-qr-reader'
import axios from 'axios';
const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
            width: '95%',
        },
    },
    subTitle: {
        fontSize: 16,
        margin: 10,
        color: "#669999"
    }
}));


const API_PATH = process.env.REACT_APP_API_PATH

const leader = 'Padlan Alqinsi'
const leader_id = 1;
export default function NewMember() {
    const history = useHistory();
    const classes = useStyles();
    let query = useQuery();
    const [isScan, setisScan] = useState(false)
    const [chip_id, setChip_id] = useState("")
    const [fullname, setFullname] = useState('')
    const [contact, setConctact] = useState('')
    const [age, setAge] = useState(0)
    const [gender, setGender] = useState('')
    const [special, setSpecial] = useState("no")
    const [specialDetail, setSpecialDetail ] = useState("")

    useEffect(() => {
        let id = query.get("id")
        if (id !== null) {
            setChip_id(id)
        }
    }, [])

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }

    function handleSubmit(e) {
        e.preventDefault();
        let data = {
            chip_id:chip_id,
            fullname: fullname,
            age: age,
            gender: gender,
            leader_id:leader_id,
            special_detail:specialDetail,
            contact:contact
        }
        console.log(data);
        axios.post(API_PATH + '/newmember',data)
        .then((res)=>{
            history.push('/mygroup')
            
        })
        .catch((err)=>{
            if(err) throw err;
        })
    }

    return (
        <div>
            <Box component="div" overflow="visible">

            {/* <IconButton aria-label="delete">
                <CropFreeIcon />
                <Typography onClick={() => setisScan(true)}>Scan QR Code</Typography>
            </IconButton> */}
            <form className={classes.root} noValidate autoComplete="off" onSubmit={handleSubmit}>
                <TextField id="filled-basic" label="ID Number" variant="filled" value={chip_id} disabled />
                <TextField id="filled-basic" label="Team Leader" value={leader} variant="filled" disabled />
                {/* <Typography className={classes.subTitle}>New Member Information</Typography> */}
                <TextField id="standard-basic" label="Fullname" value={fullname} onChange={e => setFullname(e.target.value)} type="text" />
                <TextField id="standard-basic" label="Age" value={age} onChange={e => setAge(e.target.value)} type="number" />
                <TextField id="standard-basic" label="Contact" value={contact} onChange={e => setConctact(e.target.value.toString())} type="number" />
                <FormLabel component="legend">Gender</FormLabel>
                <RadioGroup row aria-label="gender" name="gender1" value={gender} onChange={e => setGender(e.target.value)}>
                    <FormControlLabel value="m" control={<Radio />} label="Male" />
                    <FormControlLabel value="f" control={<Radio />} label="Female" />
                </RadioGroup>
                <FormLabel component="legend">Is there special need?</FormLabel>
                <RadioGroup row aria-label="special" name="special" value={special} onChange={e => setSpecial(e.target.value)}>
                    <FormControlLabel value="no" control={<Radio />} label="No" />
                    <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                </RadioGroup>
                <TextField
                    id="standard-multiline-flexible"
                    label="Special Needs Detail"
                    multiline
                    rowsMax={4}
                    value={specialDetail}
                    onChange={e => setSpecialDetail(e.target.value)}
                    variant="outlined"
                    style={{ display: (special == "yes") ? "block" : "none"}}
                    />
                <Button variant="contained" color="primary" disableElevation type="submit">Submit</Button>
            </form>
            </Box>
        </div>
    )
}
